import * as Tone from "tone";
import { ComposerUI } from "./ui/ComposerUI";
import { ComposerEngine } from "./engine/ComposerEngine";
import { ComposerProject } from "./project/ComposerProject";
import UndoManager from "../../../library-js/undo/UndoManager";
import { OnClick } from "../../dom-tools/EventListeners";
import { OnAnimationFrame } from "../../animation/OnAnimationFrame";
import { EventsCache, NoteEventData } from "./engine/EventCache";
import { Note } from "./notes/Note";
import { LCG } from "../../random/LCG";

export class Composer
{ 
  static _instance:Composer;
  undo:UndoManager = new UndoManager();
  ui:ComposerUI = new ComposerUI();  
  engine:ComposerEngine = new ComposerEngine();
  project:ComposerProject = new ComposerProject();
  activeArrangement:number = 0;

  element:Element;  
  #initialized:boolean = false;

  get activeTimeline()
  {
    return this.project.arrangements[ this.activeArrangement ].timeline;
  }

  get barLength()
  {
    return this.project.arrangements[ this.activeArrangement ].timeline.barLength;
  }

  get bpm()
  {
    return this.project.arrangements[ this.activeArrangement ].timeline.bpm;
  }


  static get $(){ return Composer._instance; }

  reset()
  {
    console.log( "reset" );

    this.undo = new UndoManager();
    this.ui = new ComposerUI();  
    this.engine = new ComposerEngine();
    this.project = new ComposerProject();

    this.#initialized = false;

   
  }

  stop()
  {

  }

  initialize( e:Element, onAnimationFrame:OnAnimationFrame )
  {
    console.log( "initialize" );

    this.reset();

    this.element = e;    
    this.ui.initialize( this.element, onAnimationFrame );

    let initializer = ()=>
    {      
      if ( this.#initialized )
      {
        return;
      }
      
      this.engine.initialize();
      this.#initialized = true;

      this.engine.setTimeline( this.project.arrangements[ 0 ].timeline );

      let ec = new EventsCache();
      let notes:Note[] = [];
      let randomKeys = 
      [ 
        "c4","d#4","f4","g4","g#4","b4"
      ];

      let randomEngine = new LCG();

      let hash = location.hash;

      if ( /^#?\d+/.test( hash ) )
      {
        hash = hash.replace( /^#/, "" );
        randomEngine.setSeed( parseInt( hash ) );
      }

      console.log( hash );

      notes = 
      [ 
        Note.create( "c2", 0, 4 ),
        Note.create( "c2", 4, 4 ),
        Note.create( "g1", 8, 4 ),
        Note.create( "g#1", 12, 4 )
      ];

      

      let bufferedFirst = [];

      for ( let i = 0; i < 32; i++ )
      {
        let n = new Note();
        n.keyInfo = randomEngine.from( randomKeys );
        n.start = i / 2;
        n.duration = 0.4;
        n.velocity = randomEngine.range( 0.8, 1 );

        bufferedFirst.push( n );

        let n2 = new Note();
        let n2Key = ( randomKeys.indexOf( n.keyInfo ) + 2 ) % randomKeys.length;
        n2.keyInfo = randomKeys[ n2Key ];
        n2.start = i / 2 + 0.01;
        n2.duration = 0.5;
        n2.velocity = randomEngine.range( 0.4, 0.6 );

        let n3 = new Note();
        let n3Key = ( randomKeys.indexOf( n.keyInfo ) + 4 ) % randomKeys.length;
        n3.keyInfo = randomKeys[ n3Key ];
        n3.midiKey += 12;
        n3.start = i / 2 + 0.2;
        n3.duration = 0.25;
        n3.velocity = randomEngine.range( 0.1, 0.3 );        

        notes.push( n );
        notes.push( n2 );
        notes.push( n3 );
      }

      for ( let i = 0; i < 8; i++ )
      {
        let index = Math.floor( ( i / 8 ) * 32 ) ; 
        let n = bufferedFirst[ index ];
        let n4 = new Note();
        n4.midiKey = n.midiKey + 24;
        n4.start = i * 2;
        n4.duration = 1.8;
        n4.velocity = 0.2;
        notes.push( n4 );
      }
      

      let instrument = new Tone.PolySynth().toDestination();

      let sampleFiles = 
      [
        "Instr-C5"
      ]

      let samples:any = {};

      for ( let i = 0; i  < sampleFiles.length; i++ )
      {
        let key = /(\w\#?\d)$/.exec( sampleFiles[ i ] )[ 1 ];

        samples[ key ] = sampleFiles[ i ] + ".wav";

        console.log( key, ">>", samples[ key ] );
      }

      let baseURL = "../../../_media/composer/ukulele/";
      let samplerInstrument = new Tone.Sampler( samples, ()=>{}, baseURL ).toDestination();
      /*
      Instr - KB4-C#5+C5.wav
      
      */

      let processNote = ( time:number, n:NoteEventData )=>
      {
        samplerInstrument.triggerAttackRelease( n.note, n.duration, undefined, n.velocity );
        //instrument.triggerAttackRelease( n.note, n.duration, undefined, n.velocity );
      };

      notes.forEach( n => { n.midiKey += 12 } );
      ec.addParts( notes, processNote );

      OnClick.remove( this.element as HTMLElement, initializer );
    }

    //OnClick.add( this.element as HTMLElement, initializer );
  }


  static start( e:Element, onAnimationFrame:OnAnimationFrame )
  {
    console.log( "start" );

    if ( Composer._instance == null )
    {
      Composer._instance = new Composer();
    }
    else
    {
      Composer._instance.stop();
    }

    Composer._instance.initialize( e, onAnimationFrame );

  }

}